import { makeStyles } from '@material-ui/core';
import React from 'react';
import image from '../images/memberdata.png';
import { isCampaignOngoing } from '../utils';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexBasis: '100%',
    justifyContent: 'center',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    fontSize: 14,
    fontWeight: 'bold',
    margin: theme.spacing(2),

    [theme.breakpoints.up('sm')]: {
      margin: theme.spacing(0, 0, 2, 0),
    },
  },
}));

export default () => {
  const classes = useStyles();

  if (!isCampaignOngoing()) {
    return <></>;
  }

  return (
    <div className={classes.root}>
      <div className={classes.container}>
        <a href="/activity/ooha" target="_blank">
          <img src={image} alt="" width="100%" height="100%" />
        </a>
        <div>
          即日起凡完成以下基本資料填寫並按下更新，即可至活動機台免費兌換「OOHA氣泡飲」蜂蜜檸檬口味一瓶。
        </div>
        <a
          href="/activity/ooha"
          target="_blank"
          style={{
            color: 'rgb(0,145,215)',
          }}
        >
          活動詳情及活動機台位置請按此。
        </a>
      </div>
    </div>
  );
};
